import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';

const Select = (props) => {
  const {
    id,
    options,
    defaultOption,
    value,
    onChange,
    required,
    disabled,
  } = props;

  return (
    <select
      id={id}
      value={value}
      onChange={onChange}
      required={required}
      disabled={disabled}
    >
      {!isEmpty(defaultOption) && (
        <option disabled={required} value={defaultOption.value}>
          {defaultOption.label}
        </option>
      )}
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default Select;

Select.propTypes = {
  id: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
      label: PropTypes.string,
    })
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  defaultOption: PropTypes.shape(),
  required: PropTypes.bool,
  disabled: PropTypes.bool,
};

Select.defaultProps = {
  defaultOption: {},
  required: false,
  disabled: false,
};
